var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClutchChampionBadge = function SvgClutchChampionBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 235 200"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clutchChampionBadge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#clutchChampionBadge_svg__b)",
    fillRule: "evenodd",
    d: "M34.413 130.595H.9l11.824-17.901L.9 93.838h33.513z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clutchChampionBadge_svg__c)",
    fillRule: "evenodd",
    d: "M200.9 130.595h33.513l-11.824-17.901 11.824-18.856H200.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1B685",
    d: "m18.197 119.761 22.27 12.347L32.566 112H18.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A78557",
    d: "m216.9 119.761-22.27 12.347L202.532 112H216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17313B",
    d: "M208.468 49.979v100L118.219 200l-90.292-50.021v-100L118.219 0z",
    filter: "url(#clutchChampionBadge_svg__d)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#clutchChampionBadge_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#clutchChampionBadge_svg__f)",
    d: "M202.413 52.823v94.787l-84.516 47.417-84.565-47.417V52.823l84.565-47.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clutchChampionBadge_svg__g)",
    d: "M202.413 52.823v94.787l-84.516 47.417-84.565-47.417V52.823l84.565-47.418z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#6DCDA9",
    strokeMiterlimit: 10,
    strokeWidth: 10,
    d: "M202.414 52.823v94.787l-84.517 47.417-84.565-47.417V52.823l84.565-47.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clutchChampionBadge_svg__h)",
    fillRule: "evenodd",
    d: "M18.197 119.784c0 .119.097.216.216.216H216.9a.216.216 0 0 0 .216-.216V83.459a.216.216 0 0 0-.216-.216H18.413a.216.216 0 0 0-.216.216z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.738 45.189h-3.676v20.108h3.676zm12.215 14.015c0 3.145-2.879 3.381-3.707 3.381-2.05 0-2.563-1.848-2.563-2.949v-7.744h-2.918v7.744c0 1.927.591 3.539 1.696 4.64.985.943 2.366 1.454 3.982 1.454 1.263 0 2.288-.393 3.51-1.1v.55h3.352V51.892h-3.352zm10.169-11.852h-3.682v4.702h-2.054v2.586h2.054v10.657h3.682V54.64h2.481v-2.586h-2.481zm13.28 14.061a4.05 4.05 0 0 1-2.782.976c-2.352 0-4.116-1.678-4.116-3.942 0-2.303 1.686-3.865 4.116-3.865a4.58 4.58 0 0 1 2.822.976l.509.43 2.273-2.187-.588-.507c-1.371-1.171-3.174-1.834-5.056-1.834-4.233 0-7.329 2.927-7.329 6.987s3.175 7.065 7.329 7.065a7.57 7.57 0 0 0 5.095-1.835l.549-.507-2.312-2.186-.51.43zm15.009-8.149c-.983-.941-2.398-1.45-4.01-1.45-1.258 0-2.594.391-3.538 1.097v-7.722h-3.341v20.108h3.341V58.32c0-3.136 2.673-3.371 3.499-3.371 2.005 0 2.359 1.842 2.359 2.94v7.408h3.341V57.89c-.039-1.96-.511-3.567-1.651-4.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D2E",
    d: "M135.494 60.973c1.374 0 2.487-1.065 2.487-2.378s-1.113-2.379-2.487-2.379c-1.373 0-2.486 1.065-2.486 2.379 0 1.313 1.113 2.378 2.486 2.378"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.01 60.63c-1.299 1.255-3.07 2-4.92 1.961-3.817 0-6.572-2.864-6.572-6.788 0-3.923 2.755-6.826 6.572-6.826 1.85 0 3.621.706 4.88 1.961l.512.51 2.283-2.197-.512-.51c-1.889-1.883-4.487-2.903-7.202-2.903-5.589 0-9.8 4.276-9.8 9.965 0 5.69 4.211 9.927 9.8 9.927 2.715 0 5.313-1.02 7.202-2.904l.512-.51-2.243-2.236zm8.767 85.1v-12.26h4.737v1.226h-3.027v4.087h2.346v1.21h-2.346v5.737zm6.493 0 2.604-12.26h1.649l2.619 12.26h-1.62l-.56-3.088h-2.497l-.59 3.088zm2.422-4.314h2.043l-1.029-5.524zm7.207 4.314v-12.26h1.71v11.034h3.133v1.226zm7.529 0v-12.26h1.71v11.034h3.133v1.226zm-23.714 24.432v-.986l2.672-4.164q.299-.467.545-.869.26-.402.415-.843.169-.455.169-1.038 0-.726-.234-1.142t-.817-.415q-.493 0-.766.273a1.45 1.45 0 0 0-.376.713 4 4 0 0 0-.104.947v.35h-1.388v-.363q0-.947.247-1.622.26-.687.817-1.063.571-.377 1.505-.377 1.272 0 1.894.727.623.714.623 1.985 0 .675-.169 1.18a4.4 4.4 0 0 1-.415.947q-.26.441-.571.909l-2.413 3.684h3.321v1.167zm10.32.117q-.895 0-1.479-.402a2.44 2.44 0 0 1-.856-1.103q-.273-.7-.273-1.595v-4.528q0-.92.273-1.609.272-.7.843-1.089.584-.39 1.492-.39c.908 0 1.098.13 1.479.39q.57.388.843 1.089.273.688.273 1.609v4.528q0 .907-.286 1.608a2.35 2.35 0 0 1-.843 1.103q-.571.389-1.466.389m0-1.141q.493 0 .739-.286.26-.285.351-.726.104-.454.104-.934v-4.554q0-.506-.091-.947-.092-.454-.351-.726-.246-.273-.752-.273c-.506 0-.592.091-.765.273q-.26.272-.351.726-.09.441-.09.947v4.554q0 .48.09.934.105.441.364.726.272.285.752.286m5.171 1.024v-.986l2.672-4.164q.299-.467.545-.869.26-.402.415-.843.17-.455.169-1.038 0-.726-.233-1.142-.234-.415-.818-.415-.492 0-.765.273a1.45 1.45 0 0 0-.376.713q-.105.441-.104.947v.35h-1.388v-.363q0-.947.246-1.622.26-.687.818-1.063.57-.377 1.504-.377 1.272 0 1.894.727.624.714.623 1.985 0 .675-.168 1.18a4.4 4.4 0 0 1-.416.947q-.26.441-.57.909l-2.413 3.684h3.321v1.167zm10.048.117q-.856 0-1.427-.324a2.04 2.04 0 0 1-.856-.934q-.285-.61-.285-1.44v-.35h1.375v.233q.012.466.104.843.103.376.35.597.26.22.739.221.507 0 .766-.234.259-.246.35-.688t.091-1.011q0-.831-.312-1.35-.298-.532-1.063-.583a.3.3 0 0 0-.104-.013h-.091v-1.388h.182q.74-.026 1.063-.39.325-.363.325-1.206 0-.714-.247-1.142-.233-.428-.947-.428-.713 0-.947.48-.233.467-.259 1.207v.22h-1.375v-.35q0-.843.285-1.44t.856-.921q.584-.325 1.44-.325.87 0 1.44.325.571.324.856.934.286.597.286 1.44 0 .946-.415 1.518-.403.57-1.09.778.48.143.804.493.337.35.519.895.182.532.182 1.246 0 .933-.26 1.634a2.2 2.2 0 0 1-.83 1.077q-.57.376-1.505.376M69.42 111.81q-1.963 0-3.087-.772-1.103-.771-1.544-2.095-.441-1.346-.441-3.087v-6.374q0-1.83.44-3.176.443-1.346 1.545-2.073 1.125-.728 3.087-.728 1.852 0 2.89.64a3.4 3.4 0 0 1 1.499 1.786q.441 1.17.441 2.713v1.5h-3.132V98.6q0-.75-.088-1.367-.066-.618-.419-.97-.33-.376-1.169-.376-.837 0-1.235.397-.374.375-.485 1.037a8.6 8.6 0 0 0-.11 1.455v7.763q0 .97.154 1.61.155.618.551.949.42.308 1.125.308.817 0 1.147-.375.353-.396.441-1.036.088-.639.088-1.434v-1.61h3.132v1.434q0 1.588-.419 2.823a3.7 3.7 0 0 1-1.478 1.919q-1.035.683-2.933.683m9.352-.242V93.704h3.242v7.476h3.639v-7.476h3.264v17.864h-3.264v-8.072h-3.64v8.072zm14.18 0 3.572-17.864h3.485l3.572 17.864h-3.021l-.706-4.124h-3.11l-.727 4.124H92.95zm4.124-6.198H99.5l-1.213-7.498zm10.463 6.198.309-17.864h3.374l2.537 12.372 2.646-12.372h3.264l.331 17.864h-2.426l-.265-12.417-2.536 12.417h-1.963l-2.58-12.46-.243 12.46zm17.304 0V93.704h5.249q1.61 0 2.603.595 1.014.596 1.477 1.743.486 1.125.485 2.734 0 1.743-.595 2.823a3.55 3.55 0 0 1-1.676 1.544q-1.059.485-2.514.485h-1.765v7.94zm3.264-10.233h1.235q.882 0 1.368-.243.507-.264.683-.816.2-.574.199-1.522 0-.97-.155-1.566-.132-.617-.617-.904-.463-.287-1.478-.287h-1.235zm10.66 10.233V93.704h3.22v17.864zm13.043.242q-1.897 0-3.022-.706-1.125-.705-1.61-2.028-.485-1.325-.485-3.132v-6.683q0-1.807.485-3.087.486-1.302 1.61-1.985 1.125-.684 3.022-.684 1.94 0 3.043.684 1.125.684 1.61 1.985.507 1.28.507 3.087v6.705q0 1.786-.507 3.11-.485 1.3-1.61 2.028-1.103.706-3.043.706m0-2.404q.816 0 1.191-.353.397-.352.529-.97t.132-1.345v-8.226q0-.75-.132-1.346-.132-.595-.529-.926-.375-.353-1.191-.353-.773 0-1.169.353-.397.331-.53.926a6.2 6.2 0 0 0-.132 1.346v8.226q0 .727.11 1.345.133.618.53.97.396.353 1.191.353m9.78 2.162V93.704h2.272l4.344 10.189v-10.19h2.691v17.865h-2.161l-4.367-10.675v10.675z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clutchChampionBadge_svg__b",
    x1: 2.296,
    x2: 68.651,
    y1: 44.339,
    y2: 101.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2AE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#BD9155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#F9E2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#BD9155"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clutchChampionBadge_svg__c",
    x1: 233.017,
    x2: 166.663,
    y1: 44.339,
    y2: 101.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2AE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#BD9155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#F9E2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#BD9155"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clutchChampionBadge_svg__h",
    x1: 26.485,
    x2: 51.688,
    y1: 33.744,
    y2: 162.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2AE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#BD9155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#F9E2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#BD9155"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "clutchChampionBadge_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-165.40146 189.6233 -381.1969 -332.5041 198.734 5.405)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5272"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "clutchChampionBadge_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-165.40146 189.6233 -381.1969 -332.5041 198.734 5.405)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17313B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5272"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "clutchChampionBadge_svg__d",
    width: 180.541,
    height: 204,
    x: 27.927,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1906_11044"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "clutchChampionBadge_svg__e",
    width: 169.081,
    height: 193.622,
    x: 33.332,
    y: 5.405,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1906_11044"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clutchChampionBadge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.9 0h233.514v200H.9z"
  })))));
};
export default SvgClutchChampionBadge;